import React from "react"
import {
    PageHeader,
    Select,
    Space,
    Button,
    Modal,
    notification,
    Upload,
    Table as TableAntd,
    Alert,
    Spin,
    Typography
} from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons"
import {Table, Form} from "@q4us-sw/q4us-ui";
import {
    getFeConfig,
    submitRefTableData,
    insertNewRefTableData,
    uploadFile,
    visualizeNonEUSupportedCountryAlpha2,
    visualizeNonEUSupportedCountryVatRates,
    cancelFileUploadJob,
    visualizeWithFilter
} from "../api/api";
import TableDataSource from "../utils/TableDataSource";
import { InboxOutlined } from '@ant-design/icons';
import {CountryVatItemNonEU} from "./CountryVatItemNonEU";
import {unstable_batchedUpdates} from "react-dom";
import {Fileset, ProgressView} from "./reference/CustomsDutyRates";

const { Option } = Select;
const { Dragger } = Upload;


const CountrySelect = (props) => {
    const [country, setCountry] = React.useState({});
    const countries = []
    const load = async ()=>{
        const { data } = await visualizeNonEUSupportedCountryAlpha2() || {};
        if(data)
        {
            const {countrycodes} = data
            for (let key in countrycodes) {
                countries.push(countrycodes[key])
            }
        }

        setCountry(countries);
    }

    React.useEffect(()=>{
        load();
    },[])

    return <div style={{ height: 54, width: '100%', top: 0, paddingTop: 11 }}>
        <Select showSearch
                style={{ width: 160 }}
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={(e)=>{props.onChangeCountry(e)}}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
        >
            <Option value="ALL">All Countries</Option>
            {Object.values(country).map((country, index) => {
                return <Option key={index} value={country.iso_alpha_2}>{country.name}</Option>;
            })}
        </Select>
    </div>
};

const VatRateUploadCountrySelect = (props) => {
    const [country, setCountry] = React.useState({});
    const load = async ()=>{
        const { data } = await visualizeNonEUSupportedCountryAlpha2() || {};
        if(data)
        {
            const {countrycodes} = data
            setCountry(countrycodes);
        }


    }

    React.useEffect(()=>{
        load();
    },[])

    return <div style={{ height: 54, width: '100%', top: 0, paddingTop: 11 }}>
        <Select showSearch
                style={{ width: 280 }}
                placeholder="Select a country to Upload VAT rates"
                optionFilterProp="children"
                onChange={(e)=>{props.onChangeCountry(e)}}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
        >
            {/*<Option value="ALL">All Countries</Option>*/}
            {Object.values(country).map((country, index) => {
                return <Option key={index} value={country.iso_alpha_2}>{country.name}</Option>;
            })}
        </Select>
    </div>
};

const ProgressContext = React.createContext();

export const NonEUVatRate  = (props)=>{

    const [source, setSource] = React.useState(new TableDataSource());
    const [open, setOpen] = React.useState(false);
    const [refresh, setRefresh] = React.useState(1);
    const [selectedCountry, setSelectedCountry] = React.useState('ALL');

    const [openWindow, setOpenUKVATWindow] = React.useState(false);
    const [openWindow2, setOpenNorwayVATWindow] = React.useState(false);
    const [opt, setOpt] = React.useState({country : undefined, country_name : undefined, rate_type: undefined, country_vat_rate_id : undefined, openItem: false});
    const [errors, setErrors] = React.useState([]);
    const [showTable, setShowTable] = React.useState(false);
    const [alert, setAlerts] = React.useState({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
    const [info, setInfo] = React.useState(undefined)
    const [err, setErr] = React.useState(undefined)

    const columns = [
        {
            title: 'Row Index',
            dataIndex: 'rowId',
            key: 'rowId',
        },
        {
            title: 'Error / Warning',
            dataIndex: 'error',
            key: 'error',
        },
        {
            title: 'Field',
            dataIndex: 'columnName',
            key: 'columnName',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
        },
    ];


    async function customUploadUKVatRates(data) {

        setAlerts({
            success: false, error: false, uploading: true, rowCount:0, uploadedRowCount:0
        });

        setShowTable(false);
        const formData = new FormData();
        formData.append('data_type', 'country_vat_rate_non_eu_uk');
        formData.append('file',data.file);
        const response = await uploadFile(formData);
        const errorMessage = 'File upload failed';

        if (response) {
            const data = response.data[0];
            const {errorList, status, noOfRowsUploaded, noOfRows, excludeRowCount, errorMsg} = data;
            setShowTable(false);
            setSource(new TableDataSource());
            setRefresh(refresh+1);

            setAlerts({
                success: true, error: false, uploading: false, rowCount:noOfRows, uploadedRowCount:noOfRowsUploaded, excludeRowCount: excludeRowCount
            });

            if (status === 'success') {
                if (errorList && errorList.length > 0) {
                    setShowTable(true);
                    const results= errorList.map(row => ({
                        key: row.id,
                        rowId: row.row,
                        columnName: row.column,
                        value: row.value,
                        error: row.error
                    }));
                    setErrors(results);
                } else {
                    setShowTable(false);
                }

            } else {
                setAlerts({
                    success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMsg
                });
                setShowTable(false);
            }
        } else {
            setAlerts({
                success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMessage
            });
        }
    }

    return <React.Fragment>
        <PageHeader title="Non-EU VAT Rates"/>
        <Space direction={`vertical`} style={{width: '100%'}}>
            <div style={{ textAlign: 'right', paddingRight: 7, width: '100%' }} >
                <Space>
                    <CountrySelect onChangeCountry={(country) =>{setSelectedCountry(country); setSource(new TableDataSource()); setRefresh(refresh+1)}} />
                    <Button style={{ width: 160 }} icon={<AppstoreAddOutlined />} onClick={() => setOpen(true)}>Add VAT Rate</Button>
                    <VatRateUploadCountrySelect onChangeCountry={(country) =>{setSelectedCountry(country);
                        if(country === 'GB') { setOpenUKVATWindow((true))} else if (country === 'NO') { {setOpenNorwayVATWindow(true)} } }} />

                </Space>
            </div>

            {refresh && selectedCountry  && <Table
                key={refresh}
                fetchConfig={async () => {
                    const { data = {} } =  await getFeConfig("country_vat_rate_non_eu")
                    const { statusCode, rows = [], fields = [] } = data;

                    const rows2 = rows.map(x => {
                        if (x.name === "country" && x.title === "Items") {
                            const dataIndex = "country";
                            const formatter = (row, index, name, type, formatted, value) =>{
                                return <React.Fragment><Space><Button Button onClick={()=>{
                                    setOpt({country: value,
                                        country_name : formatted,
                                        rate_type: row['rate_type'],
                                        country_vat_rate_id: row['id'],
                                        openItem : true})
                                }}>Items</Button></Space></React.Fragment>;
                            }
                            return {...x, dataIndex, formatter}
                        }
                        return x
                    });
                    return { data: { statusCode, rows: rows2, fields } };

                }}
                fetchData={async () => {
                    return await visualizeNonEUSupportedCountryVatRates(selectedCountry)
                }}
                scroll={{y: 'calc(90vh - 60px)', x: 'max-content' }}
                saveData={async (data) => {
                    data['timestamp'] = new Date().toUTCString();
                    data['source'] = 'MANUAL';
                    const { data: { statusCode = 400, rows = [] } = {} } = await submitRefTableData(data, 'country_vat_rate_non_eu');
                    return { data: { statusCode, rows: [data] } };
                }}

                editable={true}

                source={source}

            />}
        </Space>
        <Modal
            centered
            closable={true}
            onCancel={() => {setOpen(false)}}
            footer={null}
            title={`Add Rate Type`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'country_vat_rate_non_eu'} config={async () => {
                const res = await getFeConfig('country_vat_rate_non_eu') || {}
                const {data: {rows = []} = {}} = res;
                return rows.filter(({generated}) => !generated).sort(({sequence_no: a}, {sequence_no: b}) => {
                    return a - b
                });
            }}
                  validateField={async (rule, value, schema, column, form) => {
                      if (column.name === 'rate') {
                          const rate = form.getFieldsValue(['rate']) || {};
                          if (rate['rate'] < 0)
                              return Promise.reject(
                                  'Rate cannot be negative'
                              )
                      }
                      return Promise.resolve()
                  }}
                  submit={async (values) => {
                      values.source = 'MANUAL';
                      const {data} = await insertNewRefTableData(values, 'country_vat_rate_non_eu');
                      if (data.statusCode === 200) {
                          notification.success({message: `New record added to Non-EU Vat Rates`})
                      }
                      return true;
                  }}
            />
        </Modal>

        <Modal
            centered
            closable={true}
            onCancel={() => {
                setOpenUKVATWindow(false);
                setErrors([]);
                setAlerts({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
                setShowTable(false);

            }}
            footer={null}
            title={`VAT Rates File Upload`}
            visible={openWindow}
        >
            <div>
                <Dragger customRequest={customUploadUKVatRates} accept={".xlsx"} multiple={false} showUploadList={false}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single excel file upload.
                    </p>
                </Dragger>
            </div>
            <div style={{marginBlock: '15px'}}>
                {alert.uploading && <Alert
                    message="File uploading ....."
                    type="info"
                    showIcon
                />}
                {alert.success && <Alert
                    message="File uploaded successfully"
                    description= {`${alert.uploadedRowCount} row(s) out of  ${alert.rowCount} row(s) uploaded and ${alert.excludeRowCount} row(s) skipped with CPA code`}
                    type="success"
                    showIcon
                />}
                {alert.error && <Alert
                    message={`${alert.errorMsg}`}
                    type="error"
                    showIcon
                />}
            </div>
            <div style={{marginBlock: '15px'}}>
                {showTable && <TableAntd columns={columns} dataSource={errors} size={'middle'}>
                </TableAntd>}
            </div>
        </Modal>

        <Modal
            centered
            closable={true}
            onCancel={() => {
                unstable_batchedUpdates(()=>{
                    setOpen(false)
                    setOpenNorwayVATWindow(false);
                    setErrors([]);
                    setAlerts({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
                    setShowTable(false);
                })

            }}

            footer={null}
            title={`VAT Rates File Upload`}
            visible={openWindow2}
        >

            <ProgressView onCancel={async (id)=> {cancelFileUploadJob(({id, 'data_type':'country_vat_rate_non_eu_no' }))}}
                          fetch={ async () => {
                const {data: {rows: [first] = []}} = await visualizeWithFilter({
                    tableName: "file_upload_job",
                    conditions: [{key: "type", value: 'country_vat_rate_non_eu_no'}, {key: "status", value: 'pending'}]
                });
                return first
            }}
                onSuccess={async (id, progress, response)=>{
                    cancelFileUploadJob({id, data_type:'country_vat_rate_non_eu_no'})
                setInfo({
                    message:"VAT Rates uploaded successfully",
                    descTitle: `${response['noOfRowsUploaded']} record(s) out of  ${response['noOfRows']} records(s) uploaded, ${response['excludeRowCount']} records(s) excluded.`,
                    type:"success",
                    showIcon: true
                })
            }}>

                <ProgressContext.Consumer>
                    {p => <Spin spinning={p?.value?.progress !== undefined && p?.value?.progress !== 100}>
                        <Fileset files={[{fileId: "vat rate", title: "Norway VAT Rates File"}]}
                                 className={"file-selector"} extension={".xml"}
                                 onReady={async ({content:file, files}) => {
                            const zipFile = new File([file], 'test.zip', {type: "zip"});
                            setInfo({
                                message: "File uploading .....",
                                type:"info",
                                showIcon: true,
                                descTitle: "Uploading file ...",
                                desc: files.map(o=>`${o.title} : ${o.file.file.name}`)
                            })
                            const formData = new FormData();
                            formData.append('data_type', 'country_vat_rate_non_eu_no');
                            formData.append('file', zipFile);
                            try {
                                const {data:[first]} = await uploadFile(formData)
                                const {errorList} = first || {}
                                unstable_batchedUpdates(()=>{
                                    setErr(errorList)
                                    setInfo({
                                        message: "File upload job created...",
                                        type: "info",
                                        showIcon: true
                                    })
                                })

                            }catch (e){
                                setInfo({
                                    message: e.message,
                                    type: "error",
                                    showIcon: true
                                })
                            }
                            p?.init()
                        }
                        }/>
                    </Spin>}
                </ProgressContext.Consumer>
                {info  && <Alert {...info} description={<React.Fragment>
                    {info.descTitle && <Typography.Text>{info.descTitle}</Typography.Text>}
                    {info.desc && <ol>{info.desc.map(o=><li>{o}</li>)}</ol>}
                </React.Fragment>}/>}
                {err && <TableAntd dataSource={err} size={'small'}>
                    <TableAntd.Column title={"Error Type"} dataIndex={"error"}/>
                    <TableAntd.Column title={"Field"} dataIndex={"column"}/>
                    <TableAntd.Column title={"No. of Occurrences"} dataIndex={"occurrence"}/>
                </TableAntd>}

            </ProgressView>

        </Modal>

        <Modal
            key = {opt.openItem}
            centered
            width="80vw"
            closable={true}
            onCancel={() => {
                setOpt({country : undefined, country_name : undefined, country_vat_rate_id : undefined, openItem: false });
            }}
            footer={null}
            title={`HS6+ Codes for ${opt.rate_type} VAT type for ${opt.country_name}`}
            visible={opt.openItem}
        >
            <CountryVatItemNonEU
                country_vat_rate_id = {opt.country_vat_rate_id}
                country = {opt.country}
            />
        </Modal>
        <Modal>

        </Modal>

    </React.Fragment>
};